import { Sparkles } from 'lucide-react';
import type { AvatarConfig } from '@contracts';
import { BRIDGE_URL } from '@/lib/config';

/** Tamaño (px) de la mascota por preset. La estrella default usa su círculo de 56px. */
export const SIZE_PX: Record<NonNullable<AvatarConfig['size']>, number> = { sm: 132, md: 196, lg: 248 };

/** URL del binario del avatar (servido por BridgeHub) o null si es ícono/sin archivo. */
export function avatarSrc(assistantCode: string, av?: AvatarConfig | null): string | null {
  if (!av || !av.hasFile || (av.kind !== 'video' && av.kind !== 'image')) return null;
  return `${BRIDGE_URL}/assistant/avatar/${encodeURIComponent(assistantCode)}`;
}

/** ¿Es una mascota (archivo) y está activa? → se pinta grande y sobresale. */
export function isMascotAvatar(av?: AvatarConfig | null): boolean {
  return !!av && av.enabled !== false && (av.kind === 'video' || av.kind === 'image') && av.hasFile;
}

const MASCOT_CLS = 'h-full w-full select-none object-contain drop-shadow-[0_10px_18px_rgba(0,0,0,0.35)]';

/** Pinta el contenido del botón (estado cerrado): mascota subida o estrella default. */
export function AssistantAvatar({ assistantCode, av }: { assistantCode: string; av?: AvatarConfig | null }) {
  const src = avatarSrc(assistantCode, av);
  if (src && av?.kind === 'video') {
    return <video className={MASCOT_CLS} src={src} autoPlay loop muted playsInline disablePictureInPicture aria-label="Asistente" />;
  }
  if (src && av?.kind === 'image') {
    return <img className={MASCOT_CLS} src={src} alt="Asistente" draggable={false} />;
  }
  return (
    <span className="grid h-full w-full place-items-center bg-gradient-to-br from-orange-500 to-orange-600 text-white">
      <Sparkles className="h-6 w-6" />
    </span>
  );
}
